import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import "./UserProfile.css";

import profile from "../assets/images/profile.png";

const UserProfile = () => {
  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    rank: 4,
    completion: "10%",
    score: 0,
    days: 0,
  });

  
  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const [modules, setModules] = useState([]);

  const userId = parseInt(localStorage.getItem("userId"), 10);

  /* USER */
  useEffect(() => {
    API.get("/user/userD").then(res => {
      const u = res.data.data[0];
      setUserData(prev => ({
        ...prev,
        first_name: u.first_name,
        last_name: u.last_name,
        username: u.username,
        rank: u.rank || 4,
        completion: u.completion || "10%",
      }));
    });
  }, []);

  /* TOTAL SCORE */
  useEffect(() => {
    API.get(`/module/score/${userId}`).then(res => {
      setUserData(prev => ({ ...prev, score: res.data[0]?.score || 0 }));
    });
  }, [userId]);

  /* MODULE PROGRESS */
  useEffect(() => {
    API.get(`/module/modProfTwo/score/${userId}`).then(res => {
      setModules(res.data || []);
    });
  }, [userId]);

  const sortedModules = useMemo(() => {
    return [...modules].sort((a, b) => b.score - a.score);
  }, [modules]);

  return (
    <div className="dashboard-container">

      {/* ================= MAIN CONTENT ================= */}
      <div className="main-content">
        <h3>Your Progress</h3>

      <div className="progress-scroll">
  <div className="progress-grid">

          {sortedModules.map((m, i) => {
            const percent = Math.round(
              (m.score / m.max_number_points) * 100
            );

            return (
              <div key={i} className="progress-card">
                <h4>{m.name}</h4>
                <p className="xp">{m.score} XP</p>

                <div className="progress-bar-bg">
                  <div
                    className="progress-bar-fill"
                    style={{ width: `${percent}%` }}
                  />
                </div>

                <span className="percent">{percent}% completed</span>
              </div>
            );
          })}
        </div>
        </div>
      </div>

       <div className="sidebar">
        <div className="profile">
          <img src={profile} alt="Profile" className="profile-img" />
          <h4>{userData.first_name} {userData.last_name}</h4>
          <p>@{userData.username}</p>
        </div>
        <div className="profile-info">
          <div className="profile-info-header">
            <h4>Profile Info</h4>
            
          </div>
          <div className="info-item"><span>🏆 Rank:</span> {userData.rank}</div>
          <div className="info-item"><span>💡 Total score:</span> {userData.score}</div>
          <div className="info-item"><span>❌ Completion:</span> {userData.completion}</div>
          <div className="info-item"><span>📅 Days:</span> {userData.days}</div>
        </div>
        <div className="logout-container">
          <button onClick={handleLogout} className="logout-btn">Log out</button>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;